import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';

import MessageCenterContainer from 'components/messageCenter/MessageCenterContainer';
import { getStore } from 'store/configure';

const store = getStore();

document.addEventListener('DOMContentLoaded', () => {
  ReactDOM.render(
    <Provider store={store}>
      <MessageCenterContainer />
    </Provider>,
    document.querySelector('#hc-notifications-react-app')
  );
});
